import React, { useState } from "react";
import {
  FormGroup,
  TextField,
  Button,
  CircularProgress,
  Badge,
  IconButton,
  Avatar,
} from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { useTheme } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import { useDropzone } from "react-dropzone";
import { nanoid } from "nanoid";
import firebase from "firebase/app";
import "firebase/storage";
import CircularProgressWithLabel from "./CircularProgressWithLabel";

const db = firebase.firestore();
const storage = firebase.storage();

function EditGroupDetails({ chat }) {
  const [progress, setProgress] = React.useState(null);
  const [name, setName] = useState(chat.name);
  const [loading, setloading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [files, setFiles] = useState(null);
  const { acceptedFiles, getInputProps } = useDropzone({
    accept: "image/*",
    multiple: false,
    noDrag: true,
    maxSize: 6291456, // 6 MB
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });
  const theme = useTheme();

  function editDetails() {
    setloading(true);
    acceptedFiles.forEach((file) => {
      const storageRef = storage.ref();
      const usercontentRef = storageRef.child("rooms").child(nanoid());
      const uplostTask = usercontentRef.put(file);
      uplostTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          let progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(progress);
        },
        null,
        () => {
          uplostTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            handleSubmit(downloadURL)
            setProgress(null);
          });
        }
      );
    });
  }

  function handleSubmit(url) {
    
    db.collection("rooms")
      .doc(chat.roomID)
      .update({
        name: name,
        photoURL: url
      })
      .then(() => {
        enqueueSnackbar("group details updated!", {
          variant: "info",
        });
        setloading(false);
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong!", {
          variant: "error",
        });
        setloading(false);
      });
  };

  return (
    <FormGroup>
      <FormGroup style={{ marginBottom: 20 }} row >
        <div>
          <input {...getInputProps()} id="file-upload" />
          <Badge
            overlap="circular"
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            badgeContent={
              <label htmlFor="file-upload">
                <IconButton
                  disabled
                  style={{
                    height: 10,
                    width: 10,
                    color: "whitesmoke",
                    borderRadius: "50%",
                    backgroundColor: theme.palette.secondary.main,
                  }}
                >
                  <Edit />
                </IconButton>
              </label>
            }
          >
            {files? (
              <Avatar alt={chat.name} src={files[0].preview}>
                preview
              </Avatar>
            ) : (
              <Avatar alt={chat.name} src={chat.photoURL}>
                {chat.name[0]}
              </Avatar>
            )}
          </Badge>
        </div>
        <TextField
          style={{  marginLeft: 25,marginRight: 20 }}
          type="text"
          autoComplete="off"
          value={name}
          variant="outlined"
          placeholder="edit group name"
          label="Group Name"
          onChange={(e) => setName(e.target.value)}
        />
        {/* <CircularProgress value={progress} variant="determinate" /> */}
        {/* <div>
          <CircularProgressWithLabel value={progress} variant="determinate" />
        </div> */}
      </FormGroup>

      <Button size="large" onClick={editDetails} color="primary" variant="contained">
        {progress? (
          <CircularProgressWithLabel style={{ color: "white" }} value={progress} variant="determinate" />
        ) : (
          "Update Details"
        )}
      </Button>
    </FormGroup>
  );
}

export default EditGroupDetails;
